import React, { createContext, useState } from 'react';

export const SettingsBarContext = createContext();

export const SettingsBarProvider = ({ children }) => {
    const [isSettingsBarOpen, setIsSettingsBarOpen] = useState(false);

    const toggleSettingsBar = () => {
        setIsSettingsBarOpen(!isSettingsBarOpen);
    };

    return (
        <SettingsBarContext.Provider value={{ isSettingsBarOpen, toggleSettingsBar }}>
            {children}
        </SettingsBarContext.Provider>
    );
};

export default SettingsBarProvider;